// Zoom de la cámara: el del lente si el equipo lo permite; si no, digital (hasta 4x). Pellizco, rueda y botones 1x/2x/3x
import React, { useCallback, useEffect, useRef, useState } from 'react';

export const useZoom = (track) => {
  const cap = track?.getCapabilities?.()?.zoom;
  const hw = cap && cap.max > cap.min ? cap : null;
  const min = hw ? hw.min : 1;
  const max = hw ? hw.max : 4;
  const [zoom, setZoomState] = useState(1);
  // Cada vez que se abre arranca en 1x (aunque la cámara venga encendida de la foto anterior)
  useEffect(() => { setZoomState(hw ? Math.min(Math.max(1, hw.min), hw.max) : 1); }, [track]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (hw) track.applyConstraints({ advanced: [{ zoom }] }).catch(() => {}); }, [zoom, track]); // eslint-disable-line react-hooks/exhaustive-deps
  const setZoom = useCallback((z) => setZoomState(Math.min(max, Math.max(min, Math.round(z * 10) / 10))), [min, max]);
  return { zoom, setZoom, digital: !hw, min, max };
};

export const usePellizco = (zoom, setZoom) => {
  const ini = useRef(null);
  const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
  return {
    onTouchStart: (e) => { if (e.touches.length === 2) ini.current = { d: dist(e.touches), z: zoom }; },
    onTouchMove: (e) => { if (e.touches.length === 2 && ini.current) setZoom(ini.current.z * (dist(e.touches) / ini.current.d)); },
    onTouchEnd: () => { ini.current = null; },
    onWheel: (e) => setZoom(zoom - e.deltaY * 0.002),
  };
};

export const BarraZoom = ({ zoom, setZoom, min, max }) => {
  const pasos = [1, 2, 3, 5].filter((p) => p >= Math.floor(min) && p <= max);
  if (pasos.length < 2) return null;
  const actual = [...pasos].reverse().find((p) => zoom >= p - 0.05) ?? pasos[0];
  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5 rounded-full bg-black/50 p-1" data-testid="camara-zoom">
      {pasos.map((p) => (
        <button key={p} type="button" onClick={() => setZoom(p)} data-testid={`camara-zoom-${p}`}
          className={`h-9 min-w-9 px-2 rounded-full text-xs font-semibold transition-colors ${p === actual ? 'bg-white/90 text-yellow-600' : 'text-white hover:bg-white/20'}`}>
          {p === actual ? <span data-testid="camara-zoom-nivel">{`${Number(zoom.toFixed(1))}x`}</span> : `${p}x`}
        </button>
      ))}
    </div>
  );
};
